import { safeHttpUrl } from "@/lib/safe-http-url";
import { platformFromUrl, platformLogo } from "@/lib/str-platform";
import { urlAnswerValues } from "@/lib/url-answer";

function UrlAnswerRow({ url }: { url: string }) {
  const href = safeHttpUrl(url);
  const platform = platformFromUrl(url);
  const logo = platform ? platformLogo(platform) : null;
  const link = href ? (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="text-sm break-all underline"
    >
      {url}
    </a>
  ) : (
    <span className="text-sm break-all">{url}</span>
  );

  return (
    <div className="flex items-center gap-2">
      {logo && platform ? (
        <img src={logo} alt={platform} className="h-5 w-auto shrink-0" />
      ) : null}
      {link}
    </div>
  );
}

/** URL answers as links, with a short-term rental logo when the host matches. */
export function UrlAnswerList({ value }: { value: unknown }) {
  const urls = urlAnswerValues(value);
  if (urls.length === 0) return null;
  return (
    <div className="space-y-1">
      {urls.map((url, index) => (
        <UrlAnswerRow key={`${index}-${url}`} url={url} />
      ))}
    </div>
  );
}
